// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"ProfileImg_profileImage__0Jfu5","text":"ProfileImg_text__12IA9","logo":"ProfileImg_logo__YGhyt","downgraded":"ProfileImg_downgraded___mzwp"};